export default __webpack_public_path__ + "static/media/PlutexSwap01.c6699920.png";